module.exports = __webpack_public_path__ + "static/media/thum3.574bcf6d.jpg";